import type { ProductSection } from "./productContent";

export const TERMS_SECTIONS: readonly ProductSection[] = [
  {
    title: "Draft status",
    body: "These Terms are a working product draft for Booply and are not final lawyer-reviewed terms. They will be updated before public launch."
  },
  {
    title: "Product scope",
    body: "Booply is a closed source, text-only Spaces app for real-world groups. It does not support media, DMs, read receipts, phone-number requirements, or contact upload."
  },
  {
    title: "Plans and limits",
    body: "Booply includes Free, Plus, and Spaces plans. Paid Space slots are assignable entitlements for paid Spaces."
  },
  {
    title: "Safety and reports",
    body: "Reported content may be reviewed for safety workflows. This is an explicit exception to ordinary encrypted message handling."
  }
];

export const PRIVACY_POLICY_SECTIONS: readonly ProductSection[] = [
  {
    title: "Draft status",
    body: "This Privacy Policy is a working draft and is not final lawyer-reviewed privacy language. It will be aligned with the implemented apps and backend before launch."
  },
  {
    title: "Data minimisation",
    body: "Booply is designed around no phone number requirement, no contact upload, no media messages, no DMs, no read receipts, text-only messages, and short retention."
  },
  {
    title: "Ordinary messages",
    body: "Ordinary message plaintext should not be stored by the backend by default. Booply’s Relay is designed to route encrypted message envelopes."
  },
  {
    title: "Reports and billing",
    body: "Reported content is an exception and may include selected content for review. Billing and entitlement data is needed for Plus, Spaces, and paid Space slots."
  }
];

export const OPEN_SOURCE_NOTICE_SECTIONS: readonly ProductSection[] = [
  {
    title: "Product source model",
    body: "Booply is a closed source product with transparent documentation and respectful third-party notices where required."
  },
  {
    title: "bit.chat attribution",
    body: "Booply’s local mesh layer is inspired by, and where applicable incorporates, public-domain work from the bit.chat project."
  },
  {
    title: "Android boundary",
    body: "Booply’s Android client is cleanly reimplemented from protocol and design concepts and does not incorporate GPL-labelled Android bit.chat source code."
  },
  {
    title: "Dependency notices",
    body: "Third-party dependency notices, platform SDK notices, and license compatibility review items will be added as dependencies are introduced."
  }
];

export const SUPPORT_SECTIONS: readonly ProductSection[] = [
  {
    title: "Account and app help",
    body: "Use Support for getting started, Profile access, Devices, recovery, and future native app availability."
  },
  {
    title: "Spaces and Rooms",
    body: "Space admins can get help with Rooms, invites, join requests, members, retention and plan limits."
  },
  {
    title: "Billing",
    body: "Billing support will cover Plus, Spaces, paid Space slot assignment, cancellation and Free Limit Mode."
  },
  {
    title: "Safety",
    body: "For harassment, abuse, threats, child safety, impersonation, scams, or other safety concerns, use in-app reporting when available or the reserved safety contact."
  }
];

export const SAFETY_SECTIONS: readonly ProductSection[] = [
  {
    title: "In-app reporting",
    body: "When Booply launches, use the report action inside a Space or Room to submit the relevant message or member context for review."
  },
  {
    title: "Admin review",
    body: "Space admins should review join requests, remove members when needed, and use paid Space Review Queue tools when those tools are available."
  },
  {
    title: "Safety contact",
    body: "safety@booplyim.com is reserved for launch safety workflows. Response expectations will be documented before launch."
  },
  {
    title: "Emergency disclaimer",
    body: "Booply is not an emergency service. If someone is in immediate danger, contact local emergency services."
  }
];

export const CONTACT_SECTIONS: readonly ProductSection[] = [
  {
    title: "General support",
    body: "support@booplyim.com is reserved for launch support about accounts, apps, Spaces and membership."
  },
  {
    title: "Safety",
    body: "safety@booplyim.com is reserved for safety reports that cannot be handled through in-app reporting."
  },
  {
    title: "Billing",
    body: "billing@booplyim.com is reserved for Plus, Spaces and paid Space slot questions."
  }
];

export const DOWNLOAD_SECTIONS: readonly ProductSection[] = [
  {
    title: "App Store",
    body: "Booply’s iOS app is not listed yet, so this page does not link to a live App Store listing."
  },
  {
    title: "Google Play",
    body: "Booply’s Android app is not listed yet and will be cleanly reimplemented from protocol and design."
  },
  {
    title: "Beta access",
    body: "Beta access is not open yet. If a beta opens before launch, this page will explain availability clearly without pretending public downloads are live."
  }
];
